module.exports = __webpack_public_path__ + "static/media/leaf-oak.fb9cad5d.svg";